module.exports = __webpack_public_path__ + "static/media/04d.d8e9adfb.png";